import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./User.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IUser } from "./IUser";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import UserForm from "./UserForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";

import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listExam } from "../../Redux/Slices/Exam/ListExamSlice";
import { clearEditUserAdminResponse } from "../../Redux/Slices/UserAdmin/EditUserAdminSlice";
import { clearDeleteUserAdminResponse } from "../../Redux/Slices/UserAdmin/DeleteUserAdminSlice";
import { clearRegistrationStatus } from "../../Redux/Slices/Registration/RegistrationSlicer";
import { listUser } from "../../Redux/Slices/User/ListUserSlice";
import { listUserAdmin } from "../../Redux/Slices/UserAdmin/ListUserAdminSlice";
import { listRegion } from "../../Redux/Slices/User/ListRegionSlice";
import { listYearGroup } from "../../Redux/Slices/User/ListYearGroupSlice";
import { listRole } from "../../Redux/Slices/Role/ListRoleSlice";
import { deleteUserAdmin } from "../../Redux/Slices/UserAdmin/DeleteUserAdminSlice";
import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";

interface UserProps { }

const User: FunctionComponent<UserProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IUser>({});
  const dispatch = useAppDispatch();
  const { data: listUsers } = useAppSelector(
    (state) => state.ListUserAdminSlice
  );
  const { data: addUser } = useAppSelector((state) => state.RegistrationSlicer);
  const { data: EditUser } = useAppSelector(
    (state) => state.EditUserAdminSlice
  );
  const { data: deleteUsers } = useAppSelector(
    (state) => state.DeleteUserAdmin
  );

  const permissions = useAppSelector((state) => state.PermissionsToPage);
  const finaldata = { permissions };

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "username",
      renderHeader: () => <b>Student Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params?.row?.username === null ? "-" : params?.row?.username}
            </div>
          </>
        );
      },
    },

    {
      field: "email",
      renderHeader: () => <b>Email ID</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "parent_email",
      renderHeader: () => <b>Parent Email ID</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    // {
    //   field: "year_level",
    //   // headerName: "Year Level",
    //   renderHeader: () => <b>Year Level</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    //   renderCell: (params: GridRenderCellParams) => {
    //     return (
    //       <>
    //         <div>
    //           {params?.row?.year_level === null ? "-" : params?.row?.year_level}
    //         </div>
    //       </>
    //     );
    //   },
    // },
    {
      field: "phone_no",
      renderHeader: () => <b>Mobile Number</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params?.row?.phone_no === null ? "-" : params?.row?.phone_no}
            </div>
          </>
        );
      },
    },

    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IUser>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({
                  id: params.id,
                  name: params?.row?.student_name,
                });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const User = Array.isArray(listUsers?.data)
    ? listUsers?.data.map((user, index) => ({ ...user, index: index + 1 }))
    : [];

  useEffect(() => {
    dispatch(
      listUserAdmin({
        rolename: "STUDENT",
      })
    );
    dispatch(listRole());
    dispatch(listYearlevel_map());
    // dispatch(listSideMenuPermission());
    dispatch(listYearGroup());
  }, [addUser, EditUser, deleteUsers, dispatch]);
  useEffect(() => {
    dispatch(clearRegistrationStatus());
    dispatch(clearEditUserAdminResponse());
    dispatch(clearDeleteUserAdminResponse());
    return () => {
      dispatch(clearRegistrationStatus());
      dispatch(clearEditUserAdminResponse());
      dispatch(clearDeleteUserAdminResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={User ?? []} columns={columns} exportFileName="Students">
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({});
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() =>
              dispatch(
                listUserAdmin({
                  rolename: "STUDENT",
                })
              )
            }
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Student`}
        Dialog_Content={
          <UserForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog
        response={addUser}
        customMessage={
          addUser && addUser.status === false
            ? (Array.isArray((addUser?.data as any)?.failed) && (addUser?.data as any)?.failed?.length > 0
              ? (addUser?.data as any)?.failed?.map((item: any) => item?.error || item?.message || (typeof item === "string" ? item : "")).join(", ")
              : (addUser?.message || (addUser as any)?.error))
            : undefined
        }
        parentDialog={setDialogOpen}
        okFunction={() => dispatch(clearRegistrationStatus())}
      />
      <ResponseDialog
        response={EditUser}
        customMessage={
          EditUser && EditUser.status === false
            ? (Array.isArray((EditUser?.data as any)?.failed) && (EditUser?.data as any)?.failed?.length > 0
              ? (EditUser?.data as any)?.failed?.map((item: any) => item?.error || item?.message || (typeof item === "string" ? item : "")).join(", ")
              : (EditUser?.message || (EditUser as any)?.error))
            : undefined
        }
        parentDialog={setDialogOpen}
        okFunction={() => dispatch(clearEditUserAdminResponse())}
      />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteUserAdmin(deleteDialogData.id));
        }}
        response={deleteUsers}
      />
    </>
  );
};

export default User;
